/**
 * @author       sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  logger.ts
 */

import { createLoggerInterface } from '@zcode/logger'

export const { logger, setLogger, setLogLevel } = createLoggerInterface()
